class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.isComposing = false;

    if (!this.input) return;

    this.input.form.addEventListener('reset', this.onFormReset.bind(this));
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('input', this.onSearchInput.bind(this));
    this.input.addEventListener('compositionstart', () => {
      this.isComposing = true;
      clearTimeout(this.inputTimeout);
    });
    this.input.addEventListener('compositionend', (event) => {
      this.isComposing = false;
      this.onSearchInput(event);
    });
  }

  disconnectedCallback() {
    clearTimeout(this.inputTimeout);
  }

  getQuery() {
    if (window.WellstrapsSearch?.enabled()) return window.WellstrapsSearch.resolve(this.input.value).query;
    const query = this.input.value.trim();
    // Preserve explicit search syntax and quoted model/reference numbers.
    if (/[":\\]/.test(query)) return query;
    return query.replace(/\s+/g, ' ').replace(/\b(\d{1,2}(?:\.\d+)?)\s*(?:mm|мм)(?=$|[\s,;/)])/gi, '$1mm');
  }

  onSearchInput(event) {
    this.toggleResetButton();
    clearTimeout(this.inputTimeout);
    if (this.isComposing || event.isComposing) return;
    this.inputTimeout = setTimeout(() => this.onChange(event), 250);
  }

  toggleResetButton() {
    this.resetButton?.classList.toggle('hidden', this.input.value.length === 0);
  }

  onChange() {
    this.toggleResetButton();
  }

  onFormSubmit(event) {
    if (event.defaultPrevented || event.wellstrapsSearchPrepared) return;
    const query = this.getQuery();
    if (!query) {
      event.preventDefault();
      return;
    }
    event.wellstrapsSearchPrepared = true;
    this.input.value = window.WellstrapsSearch?.enabled()
      ? window.WellstrapsSearch.prepareForm(this.input.form, this.input.value)
      : query;
  }

  onFormReset(event) {
    // Always clear an explicit reset, including a keyboard-selected suggestion.
    event.preventDefault();
    clearTimeout(this.inputTimeout);
    this.input.value = '';
    this.input.focus();
    this.toggleResetButton();
  }
}

customElements.define('search-form', SearchForm);
